import { LeftColumn, RightColumn } from 'components/page/BaseLandingPage';
import styled from 'styled-components';

// Corporation-specific column overrides
export const CorporationLeftColumn = styled(LeftColumn)`
    & > div {
        /* Default for 1080p - fixed heights */
        height: 56.8rem;
        // Scroll is handled in individual widgets
        overflow-y: hidden;
        flex: 0 0 auto;
        display: flex;
        flex-direction: column;
    }

    /* Allow flexible heights when we have enough vertical space */
    @media (min-height: 1440px) {
        & > div {
            height: auto;
            flex: 1 1 0;
        }
    }
`;

export const CorporationRightColumn = styled(RightColumn)`
    & > div {
        /* Default for 1080p - match total height of left column */
        height: 119.2rem;
        flex: 0 0 auto;
        display: flex;
        flex-direction: column;
    }

    /* Allow flexible heights when we have enough vertical space */
    @media (min-height: 1440px) {
        & > div {
            height: auto;
            flex: 1 1 0;
        }
    }
`;
